import * as t from "io-ts";

const ManagementIO = t.intersection([
  t.type({
    schedule: t.type({ cron: t.string }),
    response_key: t.string,
    base_regex: t.string,
    key_and_regex: t.type({
      name: t.string,
      address: t.string,
      dob: t.string,
      appointed: t.string,
      position: t.string,
      occupation: t.string,
      status: t.string,
      residence: t.string,
      nationality: t.string,
    }),
    url: t.string,
  }),
  t.partial({ next_run: t.union([t.number, t.null]) }),
]);
export type ManagementT = t.TypeOf<typeof ManagementIO>;
const ShareAllotmentIO = t.array(
  t.intersection([
    t.type({
      schedule: t.type({ cron: t.string }),
      url: t.string,
      response_key: t.string,
      statement_type: t.union([t.literal("cs01"), t.literal("sh01")]),
      key_and_regex: t.type({
        date: t.string,
        share_holder: t.string,
        share_class: t.string,
        currency: t.string,
        number_of_share: t.string,
        aggregate_nominal_value: t.string,
        prescribed_class: t.string,
      }),
    }),
    t.partial({ next_run: t.union([t.number, t.null]) }),
  ]),
);
export type ShareAllotmentT = t.TypeOf<typeof ShareAllotmentIO>;
export const ConfigIO = t.partial({
  uuid: t.string,
  companyID: t.string,
  licence_no: t.string,
  share_allotment: ShareAllotmentIO,
  name: t.string,
  status: t.string,
  metadata: t.UnknownRecord,
  is_authorized: t.boolean,
  tags: t.array(t.string),
  scrape_strategy: t.string,
  priority: t.number,
  scope: t.string,
  scope_type: t.string,
  management: ManagementIO,
});

export type ConfigT = t.TypeOf<typeof ConfigIO>;
